export const mockRCIDepositsDraft = {
  steps: [
    {
      conditionals: {},
      content: {
        purchaseTypeTitle: 'Purchase type',
        accordionSuiteTypes: 'RCI points chart by suite type',
        suiteTypesTableMessage: 'The chart below will help to determine the number of points required for your desired vacation based upon the suite type and demand.',
        subtitleText: 'Deposit points',
        pointsHeading: 'Points',
        pointsDeposited: 'Points to be deposited',
        pointsAvailable: 'Points available',
        pointsToRent: 'Points to rent',
        pointsRentalHeading: 'Points Rental Cost',
        pointsRentalDescription: 'In order to deposit the points entered, you will need to rent points at a rate of $12.00 per 1,000 points.',
      },
      fieldSet: {
        purchaseTypes: {
          required: true,
          checked: false,
          label: 'Purchase types',
          help: '',
          id: 'purchase-types',
          name: 'purchaseTypes',
          type: 'select',
          options: [
            {
              label: 'All purchase types',
              value: 'allPurchaseTypes',
            },
            {
              label: 'Developer',
              value: 'developer',
            },
            {
              label: 'Resale',
              value: 'resale',
            },
          ],
          disabled: false,
          readonly: false,
          isValid: true,
        },
        depositPointsYearTwentyFour: {
          value: '154000',
          required: false,
          checked: false,
          label: '01/01/2024 - 12/31/2024 Use year',
          help: 'Points available',
          id: 'deposit-points-2024',
          name: 'depositPointsYearTwentyFour',
          type: 'checkbox',
          disabled: false,
          readonly: false,
          isValid: true,
        },
        depositPointsYearTwentyFourSpent: {
          value: '',
          required: false,
          checked: false,
          label: '',
          id: 'deposit-points-2024-spent',
          name: 'depositPointsYearTwentyFourSpent',
          type: 'text',
          disabled: false,
          readonly: false,
          isValid: true,
          min: 1000,
          max: 300000,
          useForSum: true,
        },
        depositPointsYearCurrent: {
          value: '62000',
          required: false,
          checked: false,
          label: '01/01/2025 - 06/30/2025 Use year',
          help: 'Points available',
          id: 'deposit-points-2025',
          name: 'depositPointsYearCurrent',
          type: 'checkbox',
          disabled: false,
          readonly: false,
          isValid: true,
        },
        depositPointsYearCurrentSpent: {
          value: '',
          required: false,
          checked: false,
          label: '',
          id: 'deposit-points-2025-spent',
          name: 'depositPointsYearCurrentSpent',
          type: 'text',
          disabled: false,
          readonly: false,
          isValid: true,
          min: 1000,
          max: 300000,
          useForSum: true,
        },
      },
      formState: {
        titleCompleted: '',
        purchaseTypes: '',
        depositPointsYearTwentyFour: '',
        depositPointsYearTwentyFourSpent: '',
        depositPointsYearCurrent: '',
        depositPointsYearCurrentSpent: '',
        depositPointsTotalSpent: '',
      },
      key: 'mk-deposits',
      name: 'selectDeposit',
      status: 'active',
      title: 'Select Deposit',
    },
    {
      conditionals: {
        paypal: true,
        creditCard: true,
        applePay: true,
      },
      content: {
        reviewDeposit: 'Review deposit',
        pointsDepositLabel: 'Points being deposited',
        paymentCharges: 'Payment charges',
        reservationTransaction: 'Reservation transaction',
        pointsRentalCostLabel: 'Points rental cost',
        pointsRentalCostValue: '$408.00',
        paymentAmount: '1',
        totalPaymentDueLabel: 'Total Payment Due',
        totalPaymentDueValue: '$408.00',
        paymentMethod: 'Payment method',
        emailConfirmation: 'Email confirmation',
        emailLabel: 'Please provide an email for your confirmation receipt.',
        emailDisclaimer: 'The email address provided here is for confirmation purposes only and will not be saved to your account.',
        confirmModalTitle: 'Hooray, Your Deposit is Complete!',
        confirmModalSubtitle: 'You have successfully deposited 4,000 points into the 07/01/2025 - 06/30/2026 Use Year. A confirmation email will be sent to janedoe@yourmail.com.',
        confirmModalButtonLabel: 'Return to points & benefits',
      },
      dynamicContent: {
        pointsDeposited: [
          {
            yearUsed: 'Use Year 01/01/2024 - 12/31/2024',
            pointsSpent: '12000',
          },
          {
            yearUsed: 'Use Year 01/01/2025 - 06/30/2025',
            pointsSpent: '30000',
          },
        ],
        confirmModalImage: {
          alt: 'coins',
          src: '/content/images/pile-of-coins.png',
        },
        rentedPoints: {
          label: 'Rented points',
          value: 46000,
        },
      },
      fieldSet: {
        paypal: {
          id: 'payment-method-paypal',
          label: 'PayPal',
          name: 'paymentMethod',
          paymentIcons: [
            {
              alt: 'PayPal',
              url: '/content/images/payment-icons/paypal.svg',
            },
          ],
          required: true,
          type: 'radio',
          value: 'paypal',
        },
        creditCard: {
          id: 'payment-method-credit-card',
          label: 'Credit card',
          name: 'paymentMethod',
          paymentIcons: [
            {
              alt: 'Visa',
              url: '/content/images/payment-icons/visa.svg',
            },
            {
              alt: 'Amex',
              url: '/content/images/payment-icons/amex.svg',
            },
            {
              alt: 'Mastercard',
              url: '/content/images/payment-icons/mastercard.svg',
            },
            {
              alt: 'Discover',
              url: '/content/images/payment-icons/discover.svg',
            },
          ],
          required: true,
          type: 'radio',
          value: 'creditCard',
        },
        applePay: {
          id: 'payment-method-apple-pay',
          label: 'Apple Pay',
          name: 'paymentMethod',
          paymentIcons: [
            {
              alt: 'Apple Pay',
              url: '/content/images/payment-icons/apple-pay.svg',
            },
          ],
          required: true,
          type: 'radio',
          value: 'applePay',
        },
        selectCreditCard: {
          id: 'select-credit-card',
          label: 'Select a Card',
          name: 'selectCreditCard',
          options: [
            {
              label: '•••• 4854',
              value: '4854',
            },
            {
              label: '•••• 1234',
              value: '1234',
            },
            {
              label: '•••• 4456',
              value: '4456',
            },
            {
              label: '•••• 4857 (Expired)',
              value: '4857',
            },
            {
              label: 'Add New Card',
              value: 'new',
            },
          ],
          required: true,
          type: 'select',
        },
        newCardFirstName: {
          id: 'new-credit-first-name',
          label: 'First Name',
          name: 'newCardFirstName',
          required: true,
          type: 'text',
        },
        newCardLastName: {
          id: 'new-credit-card-last-name',
          label: 'Last Name',
          name: 'newCardLastName',
          required: true,
          type: 'text',
        },
        newCardNumber: {
          id: 'new-credit-card-number',
          label: 'Card Number',
          name: 'newCardNumber',
          required: true,
          type: 'text',
        },
        newCardExpiration: {
          id: 'new-credit-card-expiration',
          label: 'Exp Date (MM/YY)',
          name: 'newCardExpiration',
          required: true,
          type: 'text',
        },
        newCardPostalCode: {
          id: 'new-credit-card-postal-code',
          label: 'Postal Code',
          name: 'newCardPostalCode',
          required: true,
          type: 'text',
        },
        emailAddress: {
          value: 'janedoe@yourmail.com',
          required: false,
          id: 'email-address',
          label: '',
          name: 'emailAddress',
          type: 'text',
          disabled: false,
          readonly: false,
          isValid: true,
          validations: [
            {
              id: '8gh401jao18d',
              message: 'Please enter valid email address',
              name: 'emailAddress',
              passing: true,
              regex: '/^[^\s@]+@[^\s@]+\.[^\s@]+$/',
            },
          ],
        },
      },
      formState: {
        paymentMethod: '',
        newCardExpiration: '',
        newCardFirstName: '',
        newCardLastName: '',
        newCardNumber: '',
        newCardPostalCode: '',
        emailAddress: '',
      },
      key: 'mk-complete-deposit',
      name: 'completeDeposit',
      status: 'incomplete',
      title: 'Complete Deposit',
    },
  ],
}

export const mockRCIPointsBySuiteType = {
  rciPointsDescription: 'The chart below will help to determine the number of points required for your desired vacation based upon the suite type and demand.',
  types: ['Demand', 'Studio', '1 Bedroom', '2 Bedroom', '3 Bedroom'],
  points: [
    {
      demand: 'Prime',
      studio: '90000',
      oneBedroom: '126000',
      twoBedroom: '205000',
      threeBedroom: '300000',
    },
    {
      demand: 'High',
      studio: '77000',
      oneBedroom: '105000',
      twoBedroom: '165000',
      threeBedroom: '232000',
    },
    {
      demand: 'Value',
      studio: '52000',
      oneBedroom: '77000',
      twoBedroom: '126000',
      threeBedroom: '159000',
    },
    {
      demand: 'Quiet',
      studio: '35000',
      oneBedroom: '63000',
      twoBedroom: '77000',
      threeBedroom: '112000',
    },
  ],
}

export const rciPointsRentCostMock = {
  value: 12,
  currency: '$',
}

export const mockRCIPurchaseTypes = {
  types: ['All purchase types', 'Developer', 'Resale'],
  messages: ['If you select "All purchase types", resale points will be deposited first. Any remaining developer points will be applied after resale points have been used.'],
}
